import React from 'react';

const Main = ({ children }) => {
  // This wrapper is redundant and should be removed. can't remove until fix tests.
  // https://swicloud.atlassian.net/browse/NH-2226
  return (
    <main data-qa="layout-main" className="nighthawk">
      {children}
    </main>
  );
};

export default Main;
